// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"clear"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14 2L10 2L10 10.5L4 10.5V15L20 15L20 10.5H14L14 2Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M4 15L4 22L20 22V15L4 15Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 15V22H20V15M4 15H20M4 15V10.5H10V2H14V10.5H20V15M15 22V19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ClearIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'clear',
    ref,
    icon: element,
  },
));

ClearIcon.displayName = 'ClearIcon';

export default ClearIcon;
